const state = {
  addWizard: {
    visible: false
  },
  addNotebookCatalog: {
    visible: false,
    data: {
      parentCatalogId: ''
    }
  },
  addNotebookNote: {
    visible: false,
    data: {
      catalogId: ''
    }
  },
  rename: {
    visible: false,
    data: {
      type: 'NOTEBOOK', // NOTEBOOK_NOTE, NOTEBOOK_CATALOG, NOTE
      id: '',
      lastName: ''
    }
  },
  insertImage: {
    visible: false
  },
  uploadImage: {
    visible: false
  },
  uploadAvatar: {
    visible: false
  }
}

const getters = {
  addWizardVisible (state) {
    return state.addWizard.visible
  },
  addNotebookCatalog (state) {
    return state.addNotebookCatalog
  },
  addNotebookNote (state) {
    return state.addNotebookNote
  },
  rename (state) {
    return state.rename
  },
  insertImage (state) {
    return state.insertImage
  },
  uploadImage (state) {
    return state.uploadImage
  },
  uploadAvatar (state) {
    return state.uploadAvatar
  }
}

const mutations = {
  SET_ADD_WIZARD_VISIBLE (state, visible) {
    state.addWizard.visible = visible
  },
  SET_ADD_NOTEBOOK_CATALOG (state, value) {
    state.addNotebookCatalog = value
  },
  SET_ADD_NOTEBOOK_NOTE (state, value) {
    state.addNotebookNote = value
  },
  SET_RENAME (state, value) {
    state.rename = value
  },
  SET_INSERT_IMAGE (state, value) {
    state.insertImage = value
  },
  SET_UPLOAD_IMAGE (state, value) {
    state.uploadImage = value
  },
  SET_UPLOAD_AVATAR (state, value) {
    state.uploadAvatar = value
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
